import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react'

type TemplateStep = 'templates' | 'social-profile' | 'introduction' | 'contact-info'

export const CurrentStepName = {
  0: 'social-profile',
  1: 'introduction',
  2: 'contact-info',
  3: 'templates',
} as { [x: number]: TemplateStep }

type TemplatesGuestProperties = {
  currentStep: number
  currentStepName: TemplateStep
}

const defaultTemplateGuestProperties: TemplatesGuestProperties = {
  currentStep: 0,
  currentStepName: 'social-profile',
}

const MainAppContext = createContext<TemplatesGuestProperties>(defaultTemplateGuestProperties)
const SetMainAppContext = createContext<Dispatch<SetStateAction<TemplatesGuestProperties>>>(
  () => {},
)

type TemplateSignInProvider = {
  children: ReactNode
}

const TemplateGuestProvider = ({ children }: TemplateSignInProvider) => {
  const [appProperties, setAppProperties] = useState<TemplatesGuestProperties>({
    ...defaultTemplateGuestProperties,
  })

  return (
    <MainAppContext.Provider value={appProperties}>
      <SetMainAppContext.Provider value={setAppProperties}>{children}</SetMainAppContext.Provider>
    </MainAppContext.Provider>
  )
}

export const useMainAppContext = () => {
  return useContext(MainAppContext)
}

export const useSetMainProperties = () => {
  const setMainProperties = useContext(SetMainAppContext)
  return (value: TemplatesGuestProperties) => {
    setMainProperties(value)
  }
}

export const useGetCurrentStep = () => {
  const context = useContext(MainAppContext)
  return context.currentStep
}

export const useSetCurrentStepName = () => {
  const setMainProperties = useContext(SetMainAppContext)
  return (stepName: TemplateStep) => {
    setMainProperties((currentProperties: TemplatesGuestProperties) => ({
      ...currentProperties,
      currentStepName: stepName,
    }))
  }
}

export const useSetCurrentStep = () => {
  const setMainProperties = useContext(SetMainAppContext)
  return (step: number) => {
    setMainProperties((currentProperties: TemplatesGuestProperties) => ({
      ...currentProperties,
      currentStep: step,
    }))
  }
}

export default TemplateGuestProvider
